// Converte um endereço em coordenadas usando a API de Geocoding do Google.
const GOOGLE_MAPS_KEY =
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||   "AIzaSyAds1TwGzvflRvD8KHrbRHrnF3DvATFM1k";


function montarTextoEndereco({ street, number, neighborhood, city, state, cep }) {
    return [
        [street, number].filter(Boolean).join(", "),
        neighborhood,
        [city, state].filter(Boolean).join(" - "),
        cep,
        "Brasil",
    ]
        .filter(Boolean)
        .join(", ");
}

const geocodeService = {
    async geocodeEndereco(endereco = {}) {
        if (!endereco.city && !endereco.cep) return null;

        try {
            const texto = encodeURIComponent(montarTextoEndereco(endereco));
            const resposta = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?address=${texto}&key=${GOOGLE_MAPS_KEY}`,
            );
            const dados = await resposta.json();

            if (dados.status !== "OK" || !dados.results?.length) return null;

            const { lat, lng } = dados.results[0].geometry.location;
            if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

            return { latitude: lat, longitude: lng };
        } catch (error) {
            console.error("Erro ao geocodificar endereço:", error);
            return null;
        }
    },
};

export default geocodeService;
